<div class="content">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon class="card-header-icon" mat-card-avatar>settings</mat-icon>
            <mat-card-title>Settings</mat-card-title>
            <mat-card-subtitle>Configure Application Settings</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>

        </mat-card-actions>
        <mat-card-content>
            <div class="row">
                <div class="column" style="flex: 0.15">
                    <mat-nav-list class="settings-nav">
                       
                    <!-- <a mat-list-item routerLink="developer"><mat-icon class="orange-icon">person</mat-icon>Developer</a>-->
                        <a mat-list-item routerLink="users" *ngIf="isLoggedInAndHasRole()">
                            <mat-icon class="orange-icon">groups</mat-icon>
                            Users
                        </a>
                         <a mat-list-item routerLink="usersunassigned" *ngIf="isLoggedInAndHasRole()">
                            <mat-icon class="orange-icon">person_off</mat-icon>
                          Unassigned Users
                        </a>
                        <a mat-list-item routerLink="organization" *ngIf="isLoggedInAndHasRole()">
                            <mat-icon class="orange-icon">business</mat-icon>
                            Organizations
                        </a>
                         <a mat-list-item routerLink="organization-settings" *ngIf="isLoggedInAndHasRole()">
                            <mat-icon class="orange-icon">settings_applications</mat-icon>
                            Organizations Settings
                        </a>
                        <ng-container *ngIf="isLoggedIn()">
                            <a mat-list-item routerLink="profile">
                               <!--<div class="profile-icon">
                                    <img src="assets/images/profile.jpg" alt="Profile Icon">
                                </div>
                                <span class="profile-text">Profile</span>-->
                                <mat-icon class="orange-icon">person</mat-icon>Profile</a>
                        </ng-container>
                        
                        <a mat-list-item  *ngIf="hasMultipleOrganizations()" (click)="changeOrg()" routerLink="organization">
                            <mat-icon style=" color: orange;">loop</mat-icon>
                           Change Organization
                        </a>
                        <a mat-list-item routerLink="change-password" *ngIf="isLoggedIn()">
                            <mat-icon style=" color: orange;">lock_reset</mat-icon>
                           Change Password
                        </a>
                        <a mat-list-item routerLink="environment"><mat-icon class="orange-icon">monitor</mat-icon>Environment</a>
                        <a mat-list-item routerLink="copilot" *ngIf="isSuperAdmin()">
                            <mat-icon class="orange-icon">smart_toy</mat-icon>
                            Copilot
                        </a>
                    </mat-nav-list>
                </div>
                <div class="column" style="flex: 1; border-left: 1px solid gray">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>